import { useI18n } from "../../i18n";
import { usePricing } from "../../context/PricingContext";
import { ChevronDown } from "lucide-react";

// CORTE 4-D2 — FAQ 100% i18n (deja de leer del CMS) + precios por país vía {price6}/{price12}
const FAQSection = ({ openFaq, toggleFaq }) => {
  const { t } = useI18n();
  const { priceLabelSemantic, display } = usePricing();
  const p6 = priceLabelSemantic(6) || "…";
  const p12 = priceLabelSemantic(12) || "…";
  // 4-D: métodos de pago SOLO del país del visitante — India jamás lee "Yape"
  const cc = display?.country;
  const seg = !cc || cc === "PE" ? "pe" : cc === "IN" ? "in" : "intl";
  const items = [1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => ({
    q: t(`faq9.q${i}`),
    a: t(`faq9.a${i}`, {
      price6: p6,
      price12: p12,
      methods: t(`faq9.methods_${seg}`),
      manual_methods: t(`faq9.manual_${seg}`),
    }),
  }));

  return (
    <section id="faq" className="bg-white py-20 md:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-[#1B84FF]">{t("faq9.eyebrow")}</p>
          <h2
            className="text-3xl font-extrabold tracking-tight text-[#0B2545] sm:text-4xl lg:text-5xl"
            data-testid="faq-title"
          >
            {t("faq9.title")}
          </h2>
        </div>

        <div className="divide-y divide-slate-200 border-y border-slate-200">
          {items.map((faq, index) => {
            const isOpen = openFaq === index;
            return (
              <div key={index} data-testid={`faq-item-${index}`}>
                <button
                  onClick={() => toggleFaq(index)}
                  className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors hover:text-[#1B84FF] focus-visible:ring-2 focus-visible:ring-[#1B84FF] focus-visible:ring-offset-2"
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${index}`}
                  data-testid={`faq-toggle-${index}`}
                >
                  <span className="font-semibold text-[#0B2545]">{faq.q}</span>
                  <ChevronDown
                    className={`mt-0.5 h-5 w-5 shrink-0 text-[#1B84FF] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                {isOpen && (
                  <div id={`faq-panel-${index}`} className="pb-6 pr-10">
                    <p className="whitespace-pre-line text-slate-600" data-testid={`faq-answer-${index}`}>
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
